import styled from 'styled-components';

export const ListDischargeSiloContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  max-height: 150px;
  margin: 1rem 0 2rem 0;
`;
